import { useState } from "react";
import { RxCross2 } from "react-icons/rx";
import { Button, Modal, ModalBody } from "reactstrap";
import NormalInput2 from "../inputs/NormalInput2";
import { useTranslation } from "../../languages";
import { toast } from "react-toastify";

const WriteFeedback = ({ isOpen, setisOpen }) => {
  const [feedbackData, setFeedbackData] = useState({
    email: "",
    title: "",
    description: "",
  });
  const { t } = useTranslation();
  return (
    <Modal
      className="custom-modal"
      centered
      size="lg"
      isOpen={isOpen}
      toggle={() => setisOpen((prev) => !prev)}
    >
      <ModalBody className="bg-white p-4" style={{ borderRadius: "28.24px" }}>
        <div className="d-flex align-items-center  justify-content-between">
          <Button
            onClick={() => setisOpen(false)}
            className="p-0 bg-primary-blue full-rounded border-none"
            style={{ height: 44, width: 44, aspectRatio: 1 }}
          >
            <RxCross2 strokeWidth={`1px`} size={20} />
          </Button>
          <h3 className="f-6  figma-shadowed-black-text m-0 ">
            {t("feedback")}
          </h3>
          <div style={{ height: 44, width: 44 }}></div>
        </div>
        <h5 className="mb-4 text-center">{t("writeFeedback")}</h5>
        <div>
          <NormalInput2
            placeholder={"Write your feedback in short message ..."}
            type={"textarea"}
            inputStyle={{ height: "200px" }}
            className={""}
            value={feedbackData?.description}
            setValue={(v) =>
              setFeedbackData((prev) => ({ ...prev, description: v }))
            }
          />
        </div>
        <div className="text-center mt-4">
          <Button
            className="standard-rounded-btn bg-primary-blue full-width text-white"
            onClick={() => {
              toast.success("Feedback submitted successfully");
              setisOpen(false);
            }}
            style={{ maxWidth: "300px" }}
          >
            {t("submit")}
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default WriteFeedback;
